import React from 'react';
import { View, Text } from 'react-native';
import { Ionicons } from '@expo/vector-icons';

/** Small calendar-cell badges for scheduled sends / show-day shares. */
export function ShareScheduleIndicators({ indicators = [], theme, compact = false }) {
  if (!indicators?.length) return null;

  const sendItems = indicators.filter((i) => i.type === 'send');
  const showItems = indicators.filter((i) => i.type === 'show');
  const accent = theme?.brand?.accent || '#2dd4bf';
  const warn = theme?.status?.warning || '#f59e0b';

  if (compact) {
    return (
      <View style={{ flexDirection: 'row', gap: 3, marginTop: 2, flexWrap: 'wrap', justifyContent: 'center' }}>
        {sendItems.length ? (
          <View
            style={{
              width: 6,
              height: 6,
              borderRadius: 3,
              backgroundColor: warn,
            }}
          />
        ) : null}
        {showItems.length ? (
          <View
            style={{
              width: 6,
              height: 6,
              borderRadius: 3,
              backgroundColor: accent,
            }}
          />
        ) : null}
      </View>
    );
  }

  return (
    <View style={{ marginTop: 4, gap: 2 }} pointerEvents="none">
      {sendItems.slice(0, 2).map((item) => (
        <View
          key={`send-${item.scheduleId}`}
          style={{
            flexDirection: 'row',
            alignItems: 'center',
            gap: 4,
            backgroundColor: `${warn}22`,
            borderRadius: 4,
            paddingHorizontal: 4,
            paddingVertical: 1,
          }}
        >
          <Ionicons name="notifications-outline" size={10} color={warn} />
          <Text style={{ fontSize: 9, fontWeight: '700', color: warn }} numberOfLines={1}>
            Sends · {(item.modules || []).slice(0, 2).join(', ')}
          </Text>
        </View>
      ))}
      {showItems.slice(0, 2).map((item) => (
        <View
          key={`show-${item.scheduleId}`}
          style={{
            flexDirection: 'row',
            alignItems: 'center',
            gap: 4,
            backgroundColor: `${accent}18`,
            borderRadius: 4,
            paddingHorizontal: 4,
            paddingVertical: 1,
          }}
        >
          <Ionicons name="paper-plane-outline" size={10} color={accent} />
          <Text style={{ fontSize: 9, fontWeight: '700', color: accent }} numberOfLines={1}>
            Share · {(item.modules || []).slice(0, 2).join(', ')}
          </Text>
        </View>
      ))}
    </View>
  );
}
